import { IMPORT_STAGE_STEP,
    SET_PROCESS_ID,
    FINISH_STAGE2_STEP,
    PREVIOUS_WIZARD,
    SET_PROCESS_FILE_NAME,
    HANDLE_PROGRESS_WINDOW,
    SET_UNIQUE_ID,
    SET_PROCESS_TYPE
 } from "../actionTypes/FileImportActionTypes";

const initialState = {
    importStageStep: "FileUpload",
    importProcessID: "",
    importUniqueID: "",
    importProcessType: "INSERT",
    importProcessFileName: null,
    fieldMappingData: {},
    fileId: '',
    showProgressWindow: false,
    isReset:true
};

const FileImportReducer =  (state = initialState, action) => {
    //console.log('Reducder file import')
    switch (action.type) {
        case IMPORT_STAGE_STEP:
            state.importStageStep = action.payload.element;
            state.fieldMappingData = action.payload.fieldMappingData;
            state.fileId = action.payload.fieldMappingData.data.file_id;
            //console.log(state.fileId+ '@@'+action.payload.fieldMappingData.data.file_id)
            return {
                ...state,
                importStageStep:state.importStageStep,
                fieldMappingData:{...state.fieldMappingData},
                fileId: state.fileId
            };
        case SET_PROCESS_ID:
            state.importProcessID = action.payload.importProcessID;
            //console.log(JSON.stringify(action.payload) + '@@ importProcessID')
            return{
                ...state,
                importProcessID: state.importProcessID 
            };
        case SET_UNIQUE_ID:
                state.importUniqueID = action.payload.importUniqueID;
                //console.log(JSON.stringify(action.payload) + '@@ importProcessID')
                return{
                    ...state,
                    importUniqueID: state.importUniqueID 
                };
        case SET_PROCESS_TYPE:
                state.importProcessType = action.payload.importProcessType;
                //console.log(JSON.stringify(action.payload) + '@@ importProcessID')
                return{
                    ...state,
                    importProcessType: state.importProcessType 
                };
        case SET_PROCESS_FILE_NAME:
            state.importProcessFileName = action.payload.importProcessFileName;
            ///console.log(JSON.stringify(action.payload) + '@@ importProcessFileName')
            return{
                ...state,
                importProcessFileName: state.importProcessFileName 
            };
        case FINISH_STAGE2_STEP:
            state.importStageStep = action.payload.importStageStep;
            return{
                ...state,
                importStageStep: state.importStageStep 
            };
        case PREVIOUS_WIZARD:
            state.importStageStep = action.payload.importStageStep;
            state.isReset = false;
            return{
                ...state,
                importStageStep: state.importStageStep
            }
        case HANDLE_PROGRESS_WINDOW:
            state.showProgressWindow = action.payload.boolean;
            return{
                ...state,
                showProgressWindow: state.showProgressWindow
            }           
        default:
            // state.importStageStep = state.importStageStep;    
            state.isReset = true;    
            return state;
    }
    
}
export default  FileImportReducer;